import { DocumentationAreaActorOrderRetrievalMethodNames } from "./DocumentationAreaActorOrderRetrievalMethodNames";
import { DocumentationAreaActorOrderRetrievalMethodConfig } from "./DocumentationAreaActorOrderRetrievalMethodDTO";

export class DocumentationAreaActorOrderRetrievalMethod {
  private readonly name: DocumentationAreaActorOrderRetrievalMethodNames;
  private readonly config: DocumentationAreaActorOrderRetrievalMethodConfig | null;

  constructor({
    name,
    config,
  }: {
    name: DocumentationAreaActorOrderRetrievalMethodNames;
    config: DocumentationAreaActorOrderRetrievalMethodConfig | null;
  }) {
    this.name = name;
    this.config = config;
  }

  public getName() {
    return this.name;
  }

  public getConfig() {
    return this.config;
  }

  public isReadonly() {
    return this.config?.readonly === true;
  }

  public isAutomaticExtraction() {
    return this.name === DocumentationAreaActorOrderRetrievalMethodNames.AUTOMATIC_EXTRACTION;
  }

  public isManualUpload() {
    return this.name === DocumentationAreaActorOrderRetrievalMethodNames.MANUAL_UPLOAD;
  }
}
